import { FC } from "react";
import clsx from "clsx";

export const SkeletonBlock: FC<{ className?: string }> = ({ className }) => (
  <div className={clsx("animate-pulse rounded-md bg-background-subtle", className)} />
);

const CARD_CLASS = "border-border-default bg-background-default flex w-full flex-col gap-4 rounded-lg border p-4 md:p-6";

export const BookingInfoSkeleton = () => (
  <div className={CARD_CLASS}>
    <SkeletonBlock className="h-6 w-40" />
    <div className="flex flex-wrap gap-6">
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className="flex flex-col gap-2">
          <SkeletonBlock className="h-3 w-16" />
          <SkeletonBlock className="h-5 w-28" />
        </div>
      ))}
    </div>
  </div>
);

export const HotelDetailsSkeleton = () => (
  <div className={CARD_CLASS}>
    <div className="flex flex-col gap-2">
      <SkeletonBlock className="h-6 w-56 max-w-full" />
      <SkeletonBlock className="h-4 w-72 max-w-full" />
    </div>
    <div className="flex flex-wrap gap-3">
      <SkeletonBlock className="h-8 w-24 rounded-full" />
      <SkeletonBlock className="h-8 w-24 rounded-full" />
    </div>
    <SkeletonBlock className="h-20 w-full" />
  </div>
);

export const PoliciesSkeleton = () => (
  <div className={CARD_CLASS}>
    <SkeletonBlock className="h-6 w-36" />
    <SkeletonBlock className="h-3 w-full" />
    <SkeletonBlock className="h-3 w-full" />
    <SkeletonBlock className="h-3 w-2/3" />
  </div>
);
